import RestApiModel from "@/api/Model/RestApiModel";

class CoverholderPolicyProduction extends RestApiModel {
  static getResourceEndpoint() {
    return '/CoverholderPolicyProduction';
  }
}

export default CoverholderPolicyProduction;
